import React, { useState } from 'react';
import { LastFocusState } from 'src/client/appTypings';
import { Focus } from 'src/client/navigation/typings';

type Value = {
  lastFocusCache: LastFocusState;
  updateLastFocus: (viewId: string, focus: Focus) => void;
  clearLastFocus: (viewId: string) => void;
};

export const ViewContext = React.createContext<Value>({
  lastFocusCache: {},
  updateLastFocus: () => {
    throw new Error('ViewContext context not initialized');
  },
  clearLastFocus: () => {
    throw new Error('ViewContext context not initialized');
  },
});

export const ViewContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [lastFocusCache, setLastFocus] = useState<LastFocusState>({});

  const updateLastFocus = (viewId: string, focus: Focus) =>
    setLastFocus(prevState => ({
      ...prevState,
      [viewId]: focus,
    }));

  const clearLastFocus = (viewId: string) =>
    setLastFocus(prevState => {
      const newState = { ...prevState };
      delete newState[viewId];
      return newState;
    });

  return (
    <ViewContext.Provider
      value={{ lastFocusCache, updateLastFocus, clearLastFocus }}
    >
      {children}
    </ViewContext.Provider>
  );
};

export const useViewContext = () => {
  return React.useContext(ViewContext);
};
